import React, {Component} from 'react'
import {NavBar,InputItem,Toast} from 'antd-mobile';
import {validation,getPhoneCode} from '../../../service/loginService';
import './style.less';
export default class getCode extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            focusIndex:0,
            getCodeText:'',
            phones:['','','','','',''],//输入的验证码数组
            check:[false,false,false,false,false,false],//输入显示选择器
            btnDisabled:true//按钮禁用状态
        };
        this._phoneChange = this._phoneChange.bind(this);
        this._getClassName = this._getClassName.bind(this);
        this._resetInputFocus = this._resetInputFocus.bind(this);
    }

    componentDidMount(){
        this._resetInputFocus();
        document.addEventListener("keydown", (e)=>{this.onKeyDown(e)})
        if(this.props.location.state.status == 0){
            this.setDownTime(60);
        }
    }
    // 倒计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeText: time});
                this.setState({btnDisabled: true});
            } else {
                this.setState({getCodeText: "00"});
                this.setState({btnDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    componentDidUpdate(){
        this._resetInputFocus();
        
       
    }
    //输入验证码之后自动验证
    validationCode =() =>{
        //模拟验证码验证错误效果
        // this.props.history.go(0);
        // Toast.info('验证码错误');
        let params = {
            "type": 1,
            "source":6,
            "phone":this.props.location.state.phone,
            "smsCode":this.state.phones[0].toString()+this.state.phones[1].toString()+this.state.phones[2].toString()+this.state.phones[3].toString()+this.state.phones[4].toString()+this.state.phones[5].toString()
        };
        validation(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    this.props.history.push(('/setPwd'),{phone:this.props.location.state.phone})
                }
                else {
                    Toast.info(res.data.msg,2,()=> this.props.history.go(0));
                   
                   
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    getCode =() =>{
        let params = {
            "type": 1,
            "source":6,
            "phone":this.props.location.state.phone
          
        };
        getPhoneCode(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    Toast.info("验证码已发送至手机！")
                    this.setDownTime(60);
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
            }).catch(function (error) {
            console.log(error);
        });
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", (e)=>{this.onKeyDown(e)})
    }

    componentWillMount(){
        this._resetInputFocus();
    }

    onKeyDown(e){
        switch( e.keyCode) {
          case 8://回退按钮
            if(this.state.focusIndex > 0 ){
                this._phoneChange('',this.state.focusIndex - 1);
            }
            // else if(this.state.focusIndex == this.state.phones.length - 1){
            //     this._phoneChange('',this.state.focusIndex);
            // }
            break;
        }
      }


    _resetInputFocus(){
         //页面加载进来时获取第一个输入框焦点
        var inputs = document.getElementsByTagName("input");
        var reset = true;
         for( var i=0;i<this.state.check.length;i++){
             if(this.state.check[i]){
                reset = false;
             }
         }
         if(reset && (typeof inputs != 'undefined' && typeof inputs[0] != 'undefined')){
                inputs[0].focus();
         }
    }

    /**
     * 返回classname 样式
     * @param {位置标识} index 
     */
    _getClassName(index){
        if(index < 0 || index > this.state.check.length - 1){
            return "";
        }
        var checked = this.state.check[index];
        if(checked && this.state.phones[index].length > 0){
            return "getCodeContentB";
        }else
        return "";
    }

    /**
     * 输入变化校验
     * @param {输入字符} value 
     * @param {位置标识} index 
     */
    _phoneChange(value,index){
        var phone = value.replace (/\s/ig, '');
        var oldPhones = this.state.phones;
        var oldChecker = this.state.check;
        var inputs = document.getElementsByTagName("input");
        
        //删除
        if(phone.length == 0){
            oldChecker[index] = false;
            if(index > 0){
                inputs[index - 1].focus();
            }
        }else{
            //输入
            oldChecker[index] = true;
            if(index < this.state.phones.length - 1){
                inputs[index + 1].focus();
            }
        }
        oldPhones[index] = phone;
                this.setState({
                    phones:oldPhones,
                    check:oldChecker,
                });

            if(index == 5){
                this.validationCode()
            }
    }

    // 获取到焦点,如果有输入时，跳转到输入的最后一个位置
    _onChangeFocus(index){
        this.setState({
            focusIndex:index
        })
        var inputs = document.getElementsByTagName("input");
        var checks = this.state.check;
        var checkEnd = -1;
        for(var i = 0; i < checks.length; i++){
            if(checks[i]){
                checkEnd = i;
            }
        }
        if(checkEnd == -1){

            inputs[0].focus();
        }else if(index - 1 != checkEnd){
            if(checkEnd + 1 < inputs.length){
                inputs[checkEnd + 1].focus();
            }
        }
        
    }
   
    
   

    render() {
        return (
            <div className="getCode">
                <NavBar
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" />}
                    onLeftClick={() => this.props.history.goBack()}
                >
                </NavBar>
                    <div className="identity">验证码已发送至手机</div>
                    <div className="checkMobile">+86{/* {this.props.location.state.phone} */}</div>
                    <div className="inputMobile">请输入验证码</div>

                <div className="getCodeContentA">
                    <InputItem
                        type="phone"
                        className={this._getClassName(0)}
                        maxLength={1}
                        onFocus={()=>{this._onChangeFocus(0)}}
                        value={this.state.phones[0]}
                        onChange={(value)=>{this._phoneChange(value,0)}}
                    />
                    <InputItem
                        type="phone"
                        className={this._getClassName(1)}
                        maxLength={1}
                        onFocus={()=>{this._onChangeFocus(1)}}
                        value={this.state.phones[1]}
                        onChange={(value)=>{this._phoneChange(value,1)}}
                    />
                    <InputItem
                        type="phone"
                        className={this._getClassName(2)}
                        maxLength={1}
                        onFocus={()=>{this._onChangeFocus(2)}}
                        value={this.state.phones[2]}
                        onChange={(value)=>{this._phoneChange(value,2)}}
                    />
                    <InputItem
                        type="phone"
                        className={this._getClassName(3)}
                        maxLength={1}
                        onFocus={()=>{this._onChangeFocus(3)}}
                        value={this.state.phones[3]}
                        onChange={(value)=>{this._phoneChange(value,3)}}
                    />
                    <InputItem
                        type="phone"
                        className={this._getClassName(4)}
                        maxLength={1}
                        onFocus={()=>{this._onChangeFocus(4)}}
                        value={this.state.phones[4]}
                        onChange={(value)=>{this._phoneChange(value,4)}}
                    />
                <InputItem
                    type="phone"
                    className={this._getClassName(5)}
                    maxLength={1}
                    onFocus={()=>{this._onChangeFocus(5)}}
                    value={this.state.phones[5]}
                    onChange={(value)=>{this._phoneChange(value,5)}}
                />
                <InputItem/>
                </div>
                <div className="downTime"><span>00:{this.state.getCodeText}</span>后  重新发送验证码</div>
                <div className="submitBox">
                    <button disabled={this.state.btnDisabled} onClick={()=>this.getCode()}>重新获取</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Login/getCode/index.js